import {OnDestroy} from "@angular/core";
import {FormBuilder} from "@angular/forms";
import {Observable} from "rxjs";
import {filter, takeUntil} from "rxjs/operators";
import {ObservableBaseForm} from "../../../forms/observable-base.form";
import {LockMixin} from "../../../mixins/lock.mixin";
import {EmptyMixin} from "../../../mixins/empty.mixin";
import {AddToCartResultModel} from "../../../models/cart/add-to-cart-result.model";
import {PriceCalculationResultModel} from "../../../models/cart/price-calculation-result.model";
import {NotificationService} from "../../../services/components/notification.service";
import { ProductCartQuantityService } from "../../../services/components/product-cart-quantity.service";
import {ProductCartService} from "../../../services/product/product-cart.service";
import { ProductService } from "../../../services/product/product.service";
import {ObservableOnDestroyMixin} from "../../../mixins/observable-on-destroy.mixin";

export abstract class AddToCartControlBaseComponent<TAddToCartForm extends ObservableBaseForm<TFormModel>, TFormModel extends object>
    extends ObservableOnDestroyMixin(LockMixin(EmptyMixin)) implements OnDestroy {

    public totalPrice: string;

    public addToCartForm: TAddToCartForm;

    protected constructor(
        protected formBuilder: FormBuilder,
        protected productCartService: ProductCartService,
        protected productService: ProductService,
        protected notificationService: NotificationService,
        protected productCartQuantityService: ProductCartQuantityService
    ) {
        super();
    }

    public ngOnDestroy(): void {
        super.ngOnDestroy();

        if(this.addToCartForm) {
            this.addToCartForm.dispose();
        }
    }

    protected handleChange(model: TFormModel): void  {
        this.lock();
        this.calculatePrice(model)
            .pipe(
                filter(this.addToCartForm.validate),
                takeUntil(this.destroy$)
             )
            .subscribe(result => {
                this.processCalculationResult(result);
                this.unLock();
            });
    }

    protected abstract calculatePrice(model: TFormModel): Observable<PriceCalculationResultModel>;

    protected processCalculationResult(result: PriceCalculationResultModel): void {
        this.totalPrice = result.totalPrice;
    }

    protected handleSubmit(model: TFormModel): void {
        this.lock();
        this.addProductToCart(model)
            .pipe(takeUntil(this.destroy$))
            .subscribe(result => {
                this.processAddToCartResult(result);
                this.unLock();
            },
            error => {
                this.unLock();
            });
    }

    protected abstract addProductToCart(model: TFormModel): Observable<AddToCartResultModel>;

    protected processAddToCartResult(result: AddToCartResultModel): void {
        this.productCartQuantityService.updateCartQuantity(result.cartQuantity);
        this.notificationService.showSuccess("", result.userMessage);
        this.addToCartForm.reset();
    }
}
